import React, { useEffect, useRef, useState } from 'react';
import useAxios from '../hook/useAxios';
import useRouter from '../hook/useRouter';

export interface IRadioSelect {
    watch: string;
    cls: string;
    title: string;
    config: { locale: string; apiDomain: string };
    path: string;
    resetObj: { [key: string]: string };
    l10n: { [key: string]: string };
    ga360str: string;
    submitCallback: (_d: string) => void;
}

export const RadioSelect = ({ props }: { props: IRadioSelect }) => {
    const { watch, cls, title, config, path, l10n, submitCallback, resetObj, ga360str } = props;
    const { res, loading, fetchData } = useAxios<{ id: string; name: string }[]>();
    const { params, getValue, changeParam } = useRouter([watch]);
    const articleRef = useRef<HTMLElement>(null);
    const [dat, datSet] = useState<{ id: string; name: string }[]>([]);
    const [checkItems, setCheckItems] = useState('0');

    // useEffect(() => {
    //     (async () => {
    //         const resp = await fetchData({ config: config, method: 'get', path: path, l10n: l10n });
    //         if (!resp) return;
    //         // resp.unshift({ id: '0', name: l10n['common.all'] });
    //         resp.unshift({ id: '0', name: '전체' });
    //         datSet(resp.map((it) => ({ id: it.id.toString(), name: it.name })));
    //     })();
    // }, []);

    useEffect(() => {
        fetchData({ config: config, method: 'get', path: path, l10n: l10n });
    }, []);

    useEffect(() => {
        if (!res) return;
        res.unshift({ id: '0', name: l10n['common.all'] });
        datSet(res.map((it) => ({ id: it.id.toString(), name: it.name })));
    }, [res]);

    useEffect(() => {
        if (!params) return;
        const value = getValue(watch);
        setCheckItems(value === '' ? '0' : value);
    }, [params]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.currentTarget.value;
        changeParam({ [watch]: val, ...resetObj });
        submitCallback(val);
    };

    return (
        <section className={cls}>
            <header>{title}</header>
            <article className="radio-wrapper" data-areas={ga360str} ref={articleRef}>
                {dat.map((it, idx) => (
                    <span className="radio" key={cls + idx + it.id}>
                        <input
                            type="radio"
                            id={`${watch}_radio_${it.id}`}
                            name={`${watch}_radio_${it.id}`}
                            value={it.id}
                            checked={checkItems === it.id}
                            onChange={onChange}
                        />
                        <label htmlFor={`${watch}_radio_${it.id}`} data-areas={ga360str}>
                            {it.name}
                        </label>
                    </span>
                ))}
            </article>
        </section>
    );
};
